import secondaryComponents from "../../../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import globalStyles from "../../../../../../assets/styles/base/globalPage.module.scss";
import { BackButton } from "../../../../../../components/primaryComponents";
import { BillsForm } from "../../../../../../components/secondaryComponents/Bills";

export const CreateBills = () => {
  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Create Bill"
      description="Create new bill"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`${globalStyles.pageColumnGaps}`}
        >
          <div className="d-flex align-items-center">
            <BackButton />
            <h4 className="ml-2 mb-0">Create Bill</h4>
          </div>

          <BillsForm />
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};
